import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-product-card-chips',
  imports: [],
  templateUrl: './product-card-chips.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardChipsComponent {
  public chipLabels = input.required<string[]>();
}
